import React from 'react';
import '../../../App.css';
import CardItem from '../../CardItem';
import Footer from '../../Footer';
import {
  solarWaterHeatingPng,
  solarWaterHeaterJpg,
  solarWaterHeater2Jpg,
} from '../../../images/assets';

export default function laptopSolarWaterHeating() {
  return(
    <>
        <div style={{backgroundColor:'rgb(248, 248, 248)'}}>

      <div style={{marginLeft:'25%' ,width:'50%', padding:20, textAlign:'center', display: 'inherit', alignItems: 'center', justifyContent: 'center',}}>
            <CardItem
              src={solarWaterHeatingPng}
              text='Solar Water Heating'
              path='/solar-waterHeating'
            />
            </div>
    <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
  
    <div >
            <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What is solar water heating?</text>
          </div>
          <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)'}}>
          <text style={{ fontSize:20}}>
              Solar heating systems can be divided into two
           groups, passive solar and active solar heating. In
          essence, these systems harvest thermal energy
         from the sun and utilize the collected heat for
          space heating purposes or to heat domestic water.
          Passive solar systems rely on the structure of the
         building to collect heat. This could be in the form
          of a tilt or a roof orientation that allows for higher
        solar irradiance. On the contrary, active solar
          heating systems rely on heat pumps that transfer
          the collected heat from the solar collectors to the building.
           </text>
          </div>
          
         
            </div>
            <div style={{marginLeft:200, width:'50%'}}>
            <CardItem
              src={solarWaterHeaterJpg}
              text='Solar Water Heater'
              path='/solar-waterHeating'
            />
            </div>
            </div>
         
            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
    <div >
    <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What are the benefits of solar water heating?</text>
          </div>
          <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>Having central source of hot water which is highly efficient and uses no energy only the sun and no running cost.</text>
            </div>
             
            </div>
            <div style={{marginLeft:200, width:'50%'}}>
            <CardItem
              src={solarWaterHeater2Jpg}
              text='Solar Heating'
              path='/solar-waterHeating'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
   
           
            </div>
            <section id="contact">
      <Footer />
      </section>
       </div>
    </>
  )
}
